import React from 'react'

const STATUS = {
  COMMUNICATING: 'Communicating',
  NON_COMM:      'Non-Communicating',
  NO_API:        'No API',
  IGN_OFF_12H:   'More than 12 hours ignition off',
}

const CARDS = [
  { label: 'Total Deployable Vehicles', key: null,                 gradient: 'linear-gradient(135deg, #642ca9 0%, #8b3fc8 100%)', shadow: 'rgba(100,44,169,0.45)' },
  { label: 'Communicating',             key: STATUS.COMMUNICATING, gradient: 'linear-gradient(135deg, #059669 0%, #10b981 100%)', shadow: 'rgba(5,150,105,0.45)'  },
  { label: '> 12h Ignition Off',        key: STATUS.IGN_OFF_12H,   gradient: 'linear-gradient(135deg, #ca8a04 0%, #eab308 100%)', shadow: 'rgba(202,138,4,0.45)'  },
  { label: 'Non-Communicating',         key: STATUS.NON_COMM,      gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)', shadow: 'rgba(220,38,38,0.45)'  },
  { label: 'No API',                    key: STATUS.NO_API,        gradient: 'linear-gradient(135deg, #0369a1 0%, #0ea5e9 100%)', shadow: 'rgba(3,105,161,0.45)'  },
]

const COMM_STATUSES = new Set(['Communicating', 'Communicating but Vehicle Off / No Network'])

function Card({ label, count, gradient, shadow }) {
  return (
    <div style={{
      background: gradient,
      borderRadius: 8,
      padding: '20px 24px',
      flex: 1,
      minWidth: 150,
      boxShadow: `0 6px 24px ${shadow}, 0 2px 6px rgba(0,0,0,0.25), 0 1px 0 rgba(255,255,255,0.10) inset`,
      border: '1px solid rgba(255,255,255,0.10)',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, height: '48%',
        background: 'linear-gradient(180deg, rgba(255,255,255,0.10) 0%, transparent 100%)',
        pointerEvents: 'none',
      }} />
      <div style={{ fontSize: 34, fontWeight: 800, color: '#fff', lineHeight: 1, position: 'relative' }}>{count}</div>
      <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.80)', marginTop: 6, fontWeight: 600, position: 'relative' }}>{label}</div>
    </div>
  )
}

export default function FleetSummaryCards({ vehicles }) {
  const deployable = vehicles.filter(v => v.mg?.drive_status === 'Deployable' && v.mg?.is_active === 'Y')
  return (
    <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 24 }}>
      {CARDS.map(({ label, key, gradient, shadow }) => {
        let count
        if (key === null)              count = deployable.length
        else if (key === 'Communicating') count = deployable.filter(v => COMM_STATUSES.has(v.status)).length
        else                           count = deployable.filter(v => v.status === key).length
        return <Card key={label} label={label} count={count} gradient={gradient} shadow={shadow} />
      })}
    </div>
  )
}
